import { FC, useState } from 'react';
import { Box, Circle, Divider, Flex, HStack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';

import { CarouselItem, CarouselItems } from '../../types';
import locales from './locales';

interface CarouselProps {
  callToActionLabel: string;
  items: CarouselItems;
  onCallToActionClick: () => void;
}

const Carousel: FC<CarouselProps> = ({
  callToActionLabel,
  items,
  onCallToActionClick,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentItem = items[currentIndex] as CarouselItem;
  const isLastItemSelected = currentIndex === items.length - 1;

  const goToNextStep = () => {
    setCurrentIndex((prevIndex) => prevIndex + 1);
  };

  return (
    <SunshineCard padding="space-0" width={600}>
      <SunshineCard.Content>
        <Flex
          alignItems="center"
          flexDirection="column"
          paddingY="space-40"
          textAlign="center"
        >
          {currentItem.image}
          <Box marginBottom="space-16" marginTop="space-24" paddingX="space-32">
            <Heading size="lg">{currentItem.title}</Heading>
          </Box>

          <Text paddingX="space-32">{currentItem.subtitle}</Text>

          <HStack marginTop="space-32" spacing="space-12">
            {items.map((item, index) => (
              <Circle
                as="button"
                bg={index === currentIndex ? 'grey.800' : 'grey.300'}
                key={item.title}
                onClick={() => setCurrentIndex(index)}
                size="space-8"
              />
            ))}
          </HStack>
        </Flex>
      </SunshineCard.Content>

      <Divider />

      <SunshineCard.Content>
        <Flex paddingX="144px" paddingY="space-24" width="100%">
          {isLastItemSelected ? (
            <Button
              icon="arrow-right"
              onClick={onCallToActionClick}
              width="100%"
            >
              {callToActionLabel}
            </Button>
          ) : (
            <Button onClick={goToNextStep} width="100%">
              {locales.next}
            </Button>
          )}
        </Flex>
      </SunshineCard.Content>
    </SunshineCard>
  );
};

export default Carousel;
